import * as React from 'react';
import { useSchedulerViewItemsContext } from '../context';
import { COLLECTION_ACTION } from '@progress/kendo-react-common';
/** @hidden */
export var useSchedulerItem = function (props, ref) {
    var _ref = props._ref, itemRef = props.itemRef;
    var item = React.useRef(null);
    var element = React.useRef(null);
    var _a = useSchedulerViewItemsContext(), dispatchItems = _a[1];
    React.useImperativeHandle(item, function () { return ({ element: element.current, props: props }); });
    React.useImperativeHandle(ref, function () { return item.current; });
    React.useImperativeHandle(_ref, function () { return item.current; });
    React.useImperativeHandle(itemRef, function () { return item.current; });
    React.useLayoutEffect(function () {
        dispatchItems({
            type: COLLECTION_ACTION.add,
            item: item
        });
        return function () {
            dispatchItems({
                type: COLLECTION_ACTION.remove,
                item: item
            });
        };
    });
    return {
        item: item,
        element: element
    };
};
